import { useEffect, useRef, useState } from "react";

export default function Viewer360({ image, onLoad }) {
  const containerRef = useRef(null);
  const viewerRef = useRef(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let viewer = null;
    
    const loadPannellum = async () => {
      try {
        // Load Pannellum CSS
        if (!document.getElementById('pannellum-css')) {
          const link = document.createElement('link');
          link.id = 'pannellum-css';
          link.rel = 'stylesheet';
          link.href = 'https://cdn.jsdelivr.net/npm/pannellum@2.5.6/build/pannellum.css';
          document.head.appendChild(link);
        }

        // Load Pannellum JS
        if (!window.pannellum) {
          await new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/pannellum@2.5.6/build/pannellum.js';
            script.onload = resolve;
            script.onerror = reject;
            document.body.appendChild(script);
          });
        }

        // Wait for container
        if (!containerRef.current) return;

        // Destroy existing viewer
        if (viewerRef.current) {
          viewerRef.current.destroy();
          viewerRef.current = null;
        }

        // Clear container
        containerRef.current.innerHTML = '';

        // Create viewer
        viewer = window.pannellum.viewer(containerRef.current, {
          type: "equirectangular",
          panorama: image,
          autoLoad: true,
          showControls: false,
          showFullscreenCtrl: false,
          showZoomCtrl: false,
          mouseZoom: true,
          keyboardZoom: true,
          friction: 0.15,
          hfov: 100,
          minHfov: 50,
          maxHfov: 120,
          autoRotate: -1,
          autoRotateInactivityDelay: 3000,
          compass: false,
          hotSpotDebug: false,
          sceneFadeDuration: 500,
        });

        viewerRef.current = viewer;

        viewer.on('load', () => {
          setError(null);
          if (onLoad) onLoad();
        });

        viewer.on('error', (err) => {
          console.error('Pannellum error:', err);
          setError('Errore nel caricamento dell\'immagine 360°');
        });

      } catch (err) {
        console.error('Failed to load Pannellum:', err);
        setError('Errore nel caricamento del viewer');
      }
    };

    loadPannellum();

    return () => {
      if (viewerRef.current) {
        try {
          viewerRef.current.destroy();
        } catch (e) {
          // Ignore cleanup errors
        }
        viewerRef.current = null;
      }
    };
  }, [image, onLoad]);

  if (error) {
    return (
      <div className="w-full h-full flex items-center justify-center bg-[#080A0E]">
        <div className="text-center p-8">
          <p className="text-[#A1A5B0] mb-4">{error}</p>
          <button 
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-[#D4AF37] text-black rounded"
          >
            Riprova
          </button>
        </div>
      </div>
    );
  }

  return (
    <div 
      ref={containerRef}
      className="w-full h-full"
      style={{ background: '#080A0E' }}
    />
  );
}
